import {
  getWalletMovementKind,
  humanName,
  icon,
  WALLET_MOVEMENT_KINDS
} from './model/constants'

type WalletMovementsConfigProps = {
  digitalProductId?: string | number
}

export const getConfig = ({ digitalProductId }: WalletMovementsConfigProps) => {
  const basePath = '/extrato-de-recompensas'
  const apiBasePath = `/user/digital_products/${digitalProductId}/wallet_movements`

  const getBreadcrumbs = (breadcrumbs: { href: string; name: string }[] = []) => [
    {
      href: basePath,
      name: humanName.plural
    },
    ...breadcrumbs
  ]

  return {
    basePath,
    apiBasePath,
    icon,
    humanName,
    infinite: true,
    pagination: {
      per_page: 20
    },
    sort: {
      field: 'updated_at',
      order: 'desc' as const
    },
    getBreadcrumbs,
    kinds: WALLET_MOVEMENT_KINDS,
    getKind: getWalletMovementKind
  }
}
